
import { Component, Vue, Prop } from 'vue-property-decorator'
import Empty from '@/components/Empty/index.vue'
import {
  getOrderDetailPage,
  queryOrderDetailById,
  completeOrder,
  deliveryOrder,
  orderCancel,
  orderReject,
  orderRefund,
  orderAccept,
  getOrderListBy,
} from '@/api/order'
import {
  formatMoney,
  dishLineTotal,
  orderDishSubtotalFrom,
  orderQuotaDiscountFrom,
  orderDiscountLabel,
  hasOrderDiscount,
  payMethodLabel,
} from '@/utils/orderAmount'
import {
  buildOrderOperationContext,
  ensureOrderStoreContext,
  loadAuthoritativeOrderContext,
} from '@/utils/orderStoreSwitch'
import { isBucketWaterDeliveryOrder as checkBucketWaterOrder } from '@/utils/bucketWaterOrder'
import { formatOrderRemarkDisplay } from '@/utils/orderRemarkDisplay'
import AdminCourierTransferDialog from '@/components/AdminCourierTransferDialog/index.vue'
import UserNameRemark from '@/components/UserNameRemark/index.vue'
import {
  isApiSuccess,
  shouldShowApiErrorMsg,
} from '@/utils/orderStoreResponseHandler'
@Component({
  name: 'Orderview',
  components: {
    Empty,
    AdminCourierTransferDialog,
    UserNameRemark,
  },
})
export default class extends Vue {
  @Prop({ default: '' }) orderStatics!: any

  private orderId = '' //订单号
  private dialogOrderStatus = 0 //弹窗所需订单状态，用于详情展示字段
  private activeIndex = 0

  private dialogVisible = false //详情弹窗
  private transferDialogVisible = false
  /** 列表行内指派/转派时，不依赖详情弹窗的 courierId */
  private transferHasCourier = false
  private cancelDialogVisible = false //取消，拒单弹窗
  private cancelDialogTitle = '' //取消，拒绝弹窗标题
  private cancelReason = ''
  private remark = '' //自定义原因
  private diaForm = []
  private row = {}
  private isAutoNext = true
  private isSearch: boolean = false
  private counts = 0
  private page: number = 1
  private pageSize: number = 10
  private status = 3
  private orderData = []
  private isTableOperateBtn = true
  private cancelOrderReasonList = [
    {
      value: 1,
      label: '订单量较多，暂时无法接单',
    },
    {
      value: 2,
      label: '商品已销售完，暂时无法接单',
    },
    {
      value: 3,
      label: '餐厅已打烊，暂时无法接单',
    },
    {
      value: 0,
      label: '自定义原因',
    },
  ]

  private cancelrReasonList = [
    {
      value: 1,
      label: '订单量较多，暂时无法接单',
    },
    {
      value: 2,
      label: '商品已销售完，暂时无法接单',
    },
    {
      value: 3,
      label: '骑手不足无法配送',
    },
    {
      value: 4,
      label: '客户电话取消',
    },
    {
      value: 0,
      label: '自定义原因',
    },
  ]
  private orderList = [
    {
      label: '全部订单',
      value: 0,
    },
    {
      label: '待付款',
      value: 1,
    },
    {
      label: '待派送',
      value: 3,
    },
    {
      label: '派送中',
      value: 4,
    },
    {
      label: '已完成',
      value: 5,
    },
    {
      label: '已取消',
      value: 6,
    },
  ]
  get tabList() {
    return [
      {
        label: '待派送',
        value: 3,
        num: this.orderStatics.confirmed,
      },
      {
        label: '派送中',
        value: 4,
        num: this.orderStatics.deliveryInProgress,
      },
    ]
  }
  get orderDishSubtotal(): string {
    return orderDishSubtotalFrom(this.diaForm)
  }

  get orderQuotaDiscount(): string {
    return orderQuotaDiscountFrom(this.diaForm)
  }

  get showOrderDiscount(): boolean {
    return hasOrderDiscount(this.diaForm)
  }

  get orderDiscountText(): string {
    return orderDiscountLabel(this.diaForm)
  }

  get storeDisplayName(): string {
    const form = this.diaForm as any
    if (!form) return '—'
    if (form.shopName) return form.shopName
    if (form.storeId != null) return `商户${form.storeId}`
    return '—'
  }

  get payMethodText(): string {
    return payMethodLabel((this.diaForm as any).payMethod, this.diaForm)
  }

  get showMixedPaySplit(): boolean {
    const form = this.diaForm as any
    if (!form) return false
    const balance = Number(form.balancePayAmount)
    const online = Number(form.onlinePayAmount)
    return Number.isFinite(balance) && balance > 0 && Number.isFinite(online) && online > 0
  }

  get onlinePayChannelName(): string {
    const form = this.diaForm as any
    const m = Number(form && form.payMethod)
    return m === 3 ? '支付宝支付' : '微信支付'
  }

  get hasCourier(): boolean {
    if (this.transferDialogVisible) {
      return this.transferHasCourier
    }
    const form = this.diaForm as any
    return !!(form && form.courierId)
  }

  formatOrderMoney(val: any) {
    return formatMoney(val)
  }

  dishLineAmount(item: any) {
    return dishLineTotal(item)
  }

  created() {
    this.getOrderListData(this.status)
  }
  // // 获取订单数据
  async getOrderListData(status) {
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      status: status,
    }
    const data = await getOrderDetailPage(params)
    const records = data.data.data.records || []
    this.orderData = records
    this.counts = data.data.data.total
    this.$emit('getOrderListBy3Status')
    if (
      this.dialogOrderStatus === 2 &&
      this.status === 2 &&
      this.isAutoNext &&
      !this.isTableOperateBtn &&
      records.length > 1
    ) {
      const row = records[0]
      this.goDetail(row.id, row.status, row, row)
    } else {
      return null
    }
  }

  //接单
  async orderAccept(row?: any, event?: any) {
    if (event && event.stopPropagation) event.stopPropagation()
    if (this.acceptingOrder) return
    if (row) this.row = row
    const ctx = buildOrderOperationContext({
      row: row || this.row,
      diaForm: this.diaForm,
      orderId: this.orderId,
      dialogOrderStatus: this.dialogOrderStatus,
    })
    if (!ctx.orderId) {
      this.$message.error('订单信息不完整，请关闭弹窗后重试')
      return
    }
    const auth = await loadAuthoritativeOrderContext(ctx.orderId)
    if (!auth || auth.orderStoreId == null) {
      this.$message.error('无法识别订单所属商户')
      return
    }
    if (auth.detail) {
      this.diaForm = auth.detail
    }
    if (!(await ensureOrderStoreContext({
      orderStoreId: auth.orderStoreId,
      orderStoreName: auth.orderStoreName,
    }))) {
      return
    }
    this.acceptingOrder = true
    this.orderId = auth.orderId
    this.dialogOrderStatus = auth.orderStatus
    orderAccept({ id: auth.orderId, storeId: auth.orderStoreId })
      .then((res) => {
        if (isApiSuccess(res.data.code)) {
          this.$message.success('操作成功')
          this.orderId = ''
          this.dialogVisible = false
          this.getOrderListData(this.status)
        } else if (!shouldShowApiErrorMsg(res.data)) {
          return
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
      .finally(() => {
        this.acceptingOrder = false
      })
  }
  //打开取消订单弹窗
  cancelOrder(row: any, event) {
    event.stopPropagation()
    this.row = row
    this.cancelDialogVisible = true
    this.orderId = row.id
    this.dialogOrderStatus = row.status
    this.cancelDialogTitle = '取消'
    this.dialogVisible = false
    this.cancelReason = ''
  }

  // 打开退款弹窗（复用取消接口：后端 cancel 在已支付时会触发退款）
  refundOrder(row: any, event) {
    event.stopPropagation()
    this.row = row
    this.cancelDialogVisible = true
    this.orderId = row.id
    this.dialogOrderStatus = row.status
    this.cancelDialogTitle = '退款'
    this.dialogVisible = false
    this.cancelReason = ''
  }
  //打开拒单弹窗
  orderReject(row?: any, event?: any) {
    if (event && event.stopPropagation) event.stopPropagation()
    const target = row || this.row
    this.row = target
    this.cancelDialogVisible = true
    this.orderId = (target as any).id
    this.dialogOrderStatus = (target as any).status
    this.cancelDialogTitle = '拒绝'
    this.dialogVisible = false
    this.cancelReason = ''
  }
  //确认取消或拒绝订单并填写原因
  async confirmCancel(type) {
    if (!this.cancelReason) {
      return this.$message.error(`请选择${this.cancelDialogTitle}原因`)
    } else if (this.cancelReason === '自定义原因' && !this.remark) {
      return this.$message.error(`请输入${this.cancelDialogTitle}原因`)
    }

    let ctx = this.getOrderOpContext()
    if (ctx.orderStoreId == null && ctx.orderId) {
      const auth = await loadAuthoritativeOrderContext(ctx.orderId)
      if (auth && auth.orderStoreId != null) {
        ctx = {
          ...ctx,
          orderStoreId: auth.orderStoreId,
          orderStoreName: auth.orderStoreName,
        }
        if (auth.detail) this.diaForm = auth.detail
      }
    }
    if (ctx.orderStoreId == null) {
      return this.$message.error('无法识别订单所属商户')
    }
    if (!(await ensureOrderStoreContext({
      orderStoreId: ctx.orderStoreId,
      orderStoreName: ctx.orderStoreName,
    }))) {
      return
    }

    const isCancel = this.cancelDialogTitle === '取消'
    const isRefund = this.cancelDialogTitle === '退款'
    const action = isRefund ? orderRefund : (isCancel ? orderCancel : orderReject)
    ;(action as any)({
      id: this.orderId,
      storeId: ctx.orderStoreId,
      // eslint-disable-next-line standard/computed-property-even-spacing
      [isCancel || isRefund ? 'cancelReason' : 'rejectionReason']:
        this.cancelReason === '自定义原因' ? this.remark : this.cancelReason,
    })
      .then(async (res) => {
        if (isApiSuccess(res.data.code)) {
          this.$message.success('操作成功')
          this.cancelDialogVisible = false
          this.orderId = ''
          this.getOrderListData(this.status)
        } else {
          await this.onOrderOpFailed(res.data.msg, res)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  // 派送，完成
  isBucketWaterDeliveryOrder(row: any): boolean {
    return checkBucketWaterOrder(row)
  }

  statusLabel(status: any): string {
    const s = Number(status)
    if (s === 2) return '待接单'
    if (s === 3) return '待派送'
    if (s === 4) return '派送中'
    if (s === 5) return '已完成'
    if (s === 6) return '已取消'
    if (s === 7) return '退款'
    return '—'
  }

  displayOrderRemark(remark: string) {
    return formatOrderRemarkDisplay(remark) || '—'
  }

  async cancelOrDeliveryOrComplete(status: number, id: string, row?: any, event?: any) {
    if (event && event.stopPropagation) event.stopPropagation()
    if (row) this.row = row
    const target = row || this.diaForm || this.row
    const isBucket = this.isBucketWaterDeliveryOrder(target)
    // 桶装水：管理员可强制完成（补空桶登记）；非桶装水 status=3 走派送
    if (isBucket && (status === 3 || status === 4)) {
      try {
        await this.$confirm(
          '该桶装水订单将由管理员强制标记为已完成，并按订单桶数登记空桶。确认继续？',
          '强制完成',
          { type: 'warning', confirmButtonText: '确认完成', cancelButtonText: '取消' }
        )
      } catch (_) {
        return
      }
      status = 4
    }
    this.orderId = id

    let ctx = this.getOrderOpContext(row)
    if (ctx.orderStoreId == null && id) {
      const auth = await loadAuthoritativeOrderContext(id)
      if (auth && auth.orderStoreId != null) {
        ctx = {
          ...ctx,
          orderStoreId: auth.orderStoreId,
          orderStoreName: auth.orderStoreName,
        }
        if (auth.detail) this.diaForm = auth.detail
      }
    }
    if (ctx.orderStoreId == null) {
      this.$message.error('无法识别订单所属商户')
      return
    }
    if (!(await ensureOrderStoreContext({
      orderStoreId: ctx.orderStoreId,
      orderStoreName: ctx.orderStoreName,
    }))) {
      return
    }
    const params = {
      status,
      id,
      storeId: ctx.orderStoreId,
    }
    ;(status === 3 ? deliveryOrder : completeOrder)(params)
      .then(async (res) => {
        if (isApiSuccess(res.data.code)) {
          this.$message.success('操作成功')
          this.orderId = ''
          this.dialogVisible = false
          this.getOrderListData(this.status)
        } else {
          await this.onOrderOpFailed(res.data.msg, res)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  private getOrderOpContext(row?: any) {
    return buildOrderOperationContext({
      row: row || this.row,
      diaForm: this.diaForm,
      orderId: this.orderId,
      dialogOrderStatus: this.dialogOrderStatus,
    })
  }

  private acceptingOrder = false

  private async onOrderOpFailed(msg: string, res?: any) {
    if (!shouldShowApiErrorMsg(res && res.data)) return
    this.$message.error(msg)
  }
  // 查看详情
  async goDetail(id: any, status: number, row: any, event) {
    event.stopPropagation()
    this.diaForm = []
    this.dialogVisible = true
    this.orderId = id
    this.dialogOrderStatus = status
    const { data } = await queryOrderDetailById({ orderId: id })
    this.diaForm = data.data
    this.row = row
  }

  openTransferDialog() {
    const form = this.diaForm as any
    this.transferHasCourier = !!(form && form.courierId)
    this.transferDialogVisible = true
  }

  openTransferFromRow(row: any, event?: any) {
    if (event && event.stopPropagation) event.stopPropagation()
    if (!row || !row.id) return
    this.orderId = row.id
    this.dialogOrderStatus = row.status
    this.transferHasCourier = !!row.courierId
    this.transferDialogVisible = true
  }

  async onTransferSuccess() {
    this.transferHasCourier = false
    if (this.dialogVisible && this.orderId) {
      const { data } = await queryOrderDetailById({ orderId: this.orderId })
      this.diaForm = data.data
      this.transferHasCourier = !!(data.data && data.data.courierId)
    }
    this.getOrderListData(this.status)
  }

  // 关闭弹层
  handleClose() {
    this.dialogVisible = false
  }
  // tab切换
  handleClass(index) {
    this.activeIndex = index
    this.page = 1
    const tab = this.tabList[index]
    const st = tab && tab.value != null ? Number(tab.value) : 2
    this.status = st
    this.getOrderListData(st)
  }
  // 触发table某一行
  handleTable(row, column, event) {
    event.stopPropagation()
    this.goDetail(row.id, row.status, row, event)
  }
  // 分页
  private handleSizeChange(val: any) {
    this.pageSize = val
    this.getOrderListData(this.status)
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.getOrderListData(this.status)
  }
}
